// extracted by mini-css-extract-plugin
module.exports = {"root":"DatePicker_root__70EnT"};